import { styled } from "@mui/material";
import { InternalButtonLink, InternalButtonLinkProps } from "../InternalButtonLink";

export const ModalButton1 = styled((props: InternalButtonLinkProps) => (
    <InternalButtonLink variant="text" bold {...props} />
))({});

export const ModalButton2 = styled((props: InternalButtonLinkProps) => <InternalButtonLink bold {...props} />)({});
